export type ApiErrorCode = 'NETWORK_ERROR' | 'TIMEOUT' | 'CANCELLED' | 'SERVER_ERROR' | 'CLIENT_ERROR' | 'UNKNOWN';

export class ApiError extends Error {
    readonly status: number | undefined;
    readonly url: string | undefined;
    readonly method: string | undefined;
    readonly code: ApiErrorCode;
    readonly isNetwork: boolean;
    readonly isCancelled: boolean;
    readonly isTimeout: boolean;
    /** Raw response body from the server — available for CLIENT_ERROR and SERVER_ERROR codes. */
    readonly responseData: unknown;

    constructor(
        message: string,
        options: {
            code: ApiErrorCode;
            status?: number;
            url?: string;
            method?: string;
            isNetwork?: boolean;
            isCancelled?: boolean;
            isTimeout?: boolean;
            responseData?: unknown;
        }
    ) {
        super(message);
        this.name = 'ApiError';
        this.code = options.code;
        this.status = options.status;
        this.url = options.url;
        this.method = options.method;
        this.isNetwork = options.isNetwork ?? false;
        this.isCancelled = options.isCancelled ?? false;
        this.isTimeout = options.isTimeout ?? false;
        this.responseData = options.responseData;
        // Restore prototype chain so `instanceof ApiError` works after transpilation
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
